export default {
  PAY_BY_LATER: 'PAY_BY_LATER',
  PAY_BY_INSTALMENTS: 'PAY_BY_INSTALMENTS',
  PAY_NEXT_MONTH: 'PAY_NEXT_MONTH',
  PAY_NOW: 'PAY_NOW',
}
